import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"opacity":"styles_opacity__mZvVM","on":"styles_on__st5HK","slide":"styles_slide__Avg5P","left":"styles_left__7nmKM","right":"styles_right__-Uu4s","top":"styles_top__C3iIL","bottom":"styles_bottom__E-K7n"};
export const b = b_.with('opacity');